import { useQuery } from 'convex/react';

import { api } from '../../convex/_generated/api';

export default function Schedule() {
  const currentSeason = useQuery(api.seasons.getCurrent);
  const sched = useQuery(
    api.schedule.getSchedule,
    currentSeason ? { season: currentSeason.year } : 'skip',
  );

  if (!currentSeason || !sched) return <div className="p-4">Loading…</div>;

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">{currentSeason.year} Schedule</h1>
      {sched.map((wk) => (
        <section key={wk.week} className="mb-4">
          <h2 className="font-semibold mb-2">Week {wk.week}</h2>
          <div className="grid gap-2 md:grid-cols-2">
            {wk.matchups.map((m) => (
              <div key={m.matchupId} className="border rounded p-2 bg-white shadow-sm text-sm">
                <div className="flex justify-between">
                  <span>{m.away.name}</span>
                  <span className="font-mono">
                    {m.status === 'scheduled' ? '–' : m.away.score.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>{m.home.name}</span>
                  <span className="font-mono">
                    {m.status === 'scheduled' ? '–' : m.home.score.toFixed(2)}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  {m.status === 'final'
                    ? 'Final'
                    : m.status === 'in_progress'
                      ? 'In progress'
                      : 'Scheduled'}
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
